// Naresh Comment

// React
import React, { useEffect, lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";

// 3rd party libs
import { db } from "./Firebase/firebase";
import cookie from "react-cookies";

// Utilities
import { getNotificationStatus, getUserInfo } from "./Request/UserRequests";
import {
  fetchCart,
  saveAddress,
  saveUser,
  setCurrentLocation,
} from "./Redux/Actions/userActions";

// Components
import Loading from "./Others/Loading";
import Cart from "./Pages/Cart/index";
import Report from "./User/Report/Report";
import Main from "./Login/Main";
import Home from "./User/Home/Home";
import ThankYou from "./Store/Cart/Components/ThankYou";
import OrderTab from "./User/Orders/OrderTab";
import OrderPage from "./User/Orders/OrderPage";
import OrdersStatus from "./Pages/Orders/OrdersStatus";
import ErrorBox from "./Others/ErrorBox";
import UtmCodes from "./Others/UtmCodes";
import PLP from "./Pages/PLP/PLP";
import Search from "./Pages/Search/Search";
import AddressPage from "./Pages/Cart/Components/Address & Payemnet Page";
import PlaceOrder from "./Pages/Cart/Components/Address & Payemnet Page/Components/PlaceOrder";
import PaymentAwait from "./Pages/Cart/Components/Address & Payemnet Page/Components/PaymentAwait";
import RuppeOne from "./Pages/RuppeeOne/RuppeOne";
import UserAccount from "./Pages/Accounts/UserAccount";
import PlacedOrderDetails from "./Pages/Orders/PlacedOrderDetails";
import ManageAddress from "./Pages/Accounts/Components/ManageAddress";
import AddNewAddress from "./Pages/Accounts/Components/AddNewAddress";
import EditAddress from "./Pages/Accounts/Components/EditAddress";
const PrivacyPolicy = lazy(() =>
  import("./PolicyTermConditionAboutUs/PrivacyPolicy")
);
const TermsCondition = lazy(() =>
  import("./PolicyTermConditionAboutUs/TermsCondition")
);
const AboutUs = lazy(() => import("./PolicyTermConditionAboutUs/AboutUs"));

/**
 * Landing page to route to other components
 * @returns {JSX}
 */
export default function Buyer() {
  const user = useSelector((state) => state.user.info);
  const dispatch = useDispatch();
  useEffect(() => {
    if (cookie.load("uid") && !user)
      getUserInfo()
        .then((res) => {
          let auth = localStorage.getItem("auth");
          if (auth) {
            getNotificationStatus(auth)
              .then((notify) => {
                dispatch(
                  saveUser({
                    ...res.user,
                    notification: notify?.notification || false,
                  })
                );
                dispatch(saveAddress(res.address));
                let cur = res.address?.filter((a) => a.primary === "true")?.[0];
                dispatch(setCurrentLocation(cur));
              })
              .catch((err) => console.log(err));
          } else {
            dispatch(saveUser({ ...res.user, notification: false }));
            dispatch(saveAddress(res.address));
            let cur = res.address?.filter((a) => a.primary === "true")?.[0];
            dispatch(setCurrentLocation(cur));
          }
          if (localStorage.getItem("cart")) {
            dispatch(fetchCart(localStorage.getItem("cart")));
            localStorage.removeItem("cart");
          } else {
            db.collection("Users")
              .doc(res.user.userHash)
              .get()
              .then((res) => dispatch(fetchCart(res.data()?.cart || [])))
              .catch((err) => console.log(err));
          }
        })
        .catch((err) => {
          if (err === "User not found") {
            cookie.remove("uid");
            window.location.href = "/";
          }
        });
    else if (cookie.load("visitor") && !user?.currentLocation) {
      dispatch(setCurrentLocation(cookie.load("visitor")));
      // get cart
      let cart = localStorage.getItem("cart");
      dispatch(fetchCart(cart ? JSON.parse(cart) : []));
    } else {
      let cart = localStorage.getItem("cart");
      dispatch(fetchCart(cart ? JSON.parse(cart) : []));
      localStorage.removeItem("cart"); // remove cart
    }
  }, [dispatch, user]);

  return (
    <BrowserRouter>
      {/* Animation */}
      <Suspense fallback={<Loading />}>
        <Routes>
          {/* Login Page */}
          <Route
            path="/"
            element={
              <UtmCodes>
                <ErrorBox>
                  <Main />
                </ErrorBox>
              </UtmCodes>
            }
          />

          {/* User Pages */}
          {/* Home Page */}
          <Route
            path="/home"
            element={
              <UtmCodes>
                <ErrorBox>
                  <Home />
                </ErrorBox>
              </UtmCodes>
            }
          />
          <Route
            path="/search"
            element={
              <UtmCodes>
                <ErrorBox>
                  <Search />
                </ErrorBox>
              </UtmCodes>
            }
          />

          {/* Order Page */}
          <Route
            path="/orders"
            element={
              <UtmCodes>
                <ErrorBox>
                  <OrderTab />
                </ErrorBox>
              </UtmCodes>
            }
          />
          <Route
            path="orders/:id"
            element={
              <UtmCodes>
                <ErrorBox>
                  <OrderPage />
                </ErrorBox>
              </UtmCodes>
            }
          />

          <Route
            path="orderstatus/:id"
            element={
              <UtmCodes>
                <ErrorBox>
                  <OrdersStatus />
                </ErrorBox>
              </UtmCodes>
            }
          />
          <Route
            path="/placedorderdetails/:id"
            element={
              <UtmCodes>
                <ErrorBox>
                  <PlacedOrderDetails />
                </ErrorBox>
              </UtmCodes>
            }
          />
          {/* Account Page */}
          <Route
            path="/account"
            element={
              <UtmCodes>
                <ErrorBox>
                  <UserAccount />
                </ErrorBox>
              </UtmCodes>
            }
          />
          <Route
            path="/account/manage-address"
            element={
              <UtmCodes>
                <ErrorBox>
                  <ManageAddress/>
                </ErrorBox>
              </UtmCodes>
            }
          />
           <Route
            path="/account/manage-address/addnew"
            element={
              <UtmCodes>
                <ErrorBox>
                  <AddNewAddress/>
                </ErrorBox>
              </UtmCodes>
            }
          />
             <Route
            path="/account/manage-address/edit/:id"
            element={
              <UtmCodes>
                <ErrorBox>
                  <EditAddress/>
                </ErrorBox>
              </UtmCodes>
            }
          />
          <Route
            path="/cart"
            element={
              <UtmCodes>
                <ErrorBox>
                  <Cart />
                </ErrorBox>
              </UtmCodes>
            }
          />

          {/* Store Pages */}
          {/* <Route
            path="/:store"
            element={
              <UtmCodes>
                <ErrorBox>
                  <Store />
                </ErrorBox>
              </UtmCodes>
            }
          />
        

          <Route
            path="/:store/cart/discountcoupons"
            element={
              <UtmCodes>
                <ErrorBox>
                  <DiscountCoupons></DiscountCoupons>
                </ErrorBox>
              </UtmCodes>
            }
          />

          <Route
            path="/:store/search"
            element={
              <UtmCodes>
                <ErrorBox>
                  <SearchStore />
                </ErrorBox>
              </UtmCodes>
            }
          /> */}

          {/* Free Prodcuts */}
          {/* <Route
            path="/:store/freeproduct"
            element={
              <UtmCodes>
                <ErrorBox>
                  <StoreFreeProduct />
                </ErrorBox>
              </UtmCodes>
            }
          />
          <Route
            path="/:store/freeproduct/cart"
            element={
              <UtmCodes>
                <ErrorBox>
                  <CartFreeProduct />
                </ErrorBox>
              </UtmCodes>
            }
          /> */}
          {/* Report Pages */}
          <Route
            path="/report"
            element={
              <UtmCodes>
                <ErrorBox>
                  <Report />
                </ErrorBox>
              </UtmCodes>
            }
          />

          <Route
            path="/place-order"
            element={
              <UtmCodes>
                <ErrorBox>
                  <PlaceOrder />
                </ErrorBox>
              </UtmCodes>
            }
          />

          <Route
            path="/payment-await"
            element={
              <UtmCodes>
                <ErrorBox>
                  <PaymentAwait />
                </ErrorBox>
              </UtmCodes>
            }
          />
          <Route
            path="/thank-you"
            element={
              <UtmCodes>
                <ErrorBox>
                  <ThankYou />
                </ErrorBox>
              </UtmCodes>
            }
          />
          <Route
            path="/:category"
            element={
              <UtmCodes>
                <ErrorBox>
                  <PLP />
                </ErrorBox>
              </UtmCodes>
            }
          />
          <Route
            path="/address"
            element={
              <UtmCodes>
                <ErrorBox>
                  <AddressPage />
                </ErrorBox>
              </UtmCodes>
            }
          />
          {/* //rahul rupee one */}
          <Route path="rupee-one" element={<RuppeOne />} />
          {/* <Route path="search" element={<Search />} /> */}

          <Route path="privacyPolicy" element={<PrivacyPolicy />} />
          <Route path="termsCondition" element={<TermsCondition />} />
          <Route path="aboutUs" element={<AboutUs />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}
